var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"council"},[_c('SubHeader',{attrs:{"title":"Error","subtitle":"エラー"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-12"},[_c('h2',{staticClass:"mb-4"},[_vm._v("File not found")]),_c('p',[_vm._v("ページが見つかりません。URLが間違っているか、古くなっている可能性があります。")])])])])
}]

export { render, staticRenderFns }